import { Form, Typography } from "antd";
import { NamePath } from "antd/es/form/interface";

const { Text } = Typography;

const HeaderFormField: React.FC<{
  label: string;
  name: NamePath;
  isEdit?: boolean;
  children: React.ReactNode;
}> = ({ label, name, isEdit, children }) => {
  const form = Form.useFormInstance();
  const value = Form.useWatch(name, form);

  return (
    <Form.Item
      label={<span className="text-gray-500">{label}</span>}
      name={name}
      className="mb-0"
    >
      {isEdit ? (
        children
      ) : (
        <Text className="font-medium text-[14px]">
          {value ?? "---"}
        </Text>
      )}
    </Form.Item>
  );
};

export default HeaderFormField;